module.exports = __webpack_public_path__ + "img/banner-28.d91487ff.jpg";